/* lua.js generated code 0.3.0 */

UIPopoutLayoutOrder = table(
    [1, "kPanel", 1000],
    [1, "kPopoutItem", 1020],
    [1, "kFlyCoinAnimation", 1050],
    [1, "kFlyCashAnimation", 1040],
    [1, "kFlyPropAnimation", 1100]
)
UILabelColor = table(
    [1, "kWhite", cc.c4b(255, 255, 255, 255)],
    [1, "kBrown", cc.c4b(180, 119, 59, 200)],
    [1, "kGreen", cc.c4b(115, 162, 14, 255)],
    [1, "kRed", cc.c4b(220, 71, 53, 255)],
    [1, "kBlue", cc.c4b(40, 114, 147, 255)],
    [1, "kBlack", cc.c4b(0, 0, 0, 255)]
)
